import styled from 'styled-components'

export const Wrapper = styled.div`
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;

  #checkToggleBtn-1 .checkToggleBtnItem:checked + .checkToggleBody .checkToggleBodyInner {left: 0px;}
`;
